export const textConfigSchema = {
  type: 'object',
  properties: {
    heading: { type: 'boolean', description: 'Default: false' },
    fontWeight: { type: 'number' },
    size: { type: 'string', enum: ['xs', 'sm', 'md', 'lg', 'xl', '2xl'] }
  }
}
